import type { TypographyOwnProps } from "@mui/material";
import { GradientTypography } from "./GradientTypography";

export const SilverText = ({ children, ...props }: TypographyOwnProps) => {
  return (
    <GradientTypography
      gradient="linear-gradient(180deg,rgba(255,255,255,1) 40%, rgba(172,187,195,1) 100%)"
      fallbackColor="rgba(255,255,255,1)"
      {...props}
    >
      {children}
    </GradientTypography>
  );
};
